/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Template_Category_ClientsInputs */

const cs_automation_template_category_clients = /** @type {(inputs: Automation_Template_Category_ClientsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klienti`)
};

const en_automation_template_category_clients = /** @type {(inputs: Automation_Template_Category_ClientsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clients`)
};

/**
* | output |
* | --- |
* | "Clients" |
*
* @param {Automation_Template_Category_ClientsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const automation_template_category_clients = /** @type {((inputs?: Automation_Template_Category_ClientsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Template_Category_ClientsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_template_category_clients(inputs)
	return cs_automation_template_category_clients(inputs)
});